import type { FC, ReactNode } from "react";
import { Fragment } from "react";

interface Props {
  number: number;
  children: ReactNode;
}

const SkeletonList: FC<Props> = ({ number, children }) => (
  <>
    {[...new Array(number)].map((_, i) => (
      <Fragment key={"skeleton-" + i}>{children}</Fragment>
    ))}
  </>
);

SkeletonList.defaultProps = {
  number: 1,
};

export { SkeletonList };
